import {Injectable} from '@angular/core';
import {DefaultWebservice} from './default-webservice';
import {Observable} from 'rxjs';
import {Dashboard} from '../domain/dto/dashboard.dto';

@Injectable({
  providedIn: 'root'
})
export class DashboardWebservice extends DefaultWebservice {
  constructor() {
    super('dashboard');
  }

  public getDashboardData(): Observable<Dashboard> {
    return this.httpClient.get<Dashboard>(`${this.path}`);
  }
  public test(): Observable<void> {
    return this.httpClient.get<void>(`api/test`);
  }
}
